import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../base/api.service';
import { ItemCreatedResponse } from '../../entities/base/item-created-response';
import { ItemDeletedResponse } from '../../entities/base/item-deleted-response';
import { PatientDiagnosisCode } from './entities/patient-diagnosis-code';
import { AddPatientDiagnosisCodeRequest } from './entities/add-patient-diagnosis-code-request';
import { PatientDiagnosisCodeCollectionResponse } from './entities/patient-diagnosis-code-collection-response';

@Injectable({
  providedIn: 'root'
})
export class DiagnosisCodesRepositoryService {
  constructor(private api: ApiService) {}

  loadPatientDiagnosisCodes(patientId: number): Observable<PatientDiagnosisCode[]> {
    return this.api.get<PatientDiagnosisCodeCollectionResponse>('/diagnosiscodes/patient/' + patientId)
      .pipe(map(response => response.items));
  }

  addDiagnosisCodeToPatient(patientId: number, request: AddPatientDiagnosisCodeRequest): Observable<number> {
    return this.api.post<ItemCreatedResponse>('/diagnosiscodes/patient/' + patientId, request)
      .pipe(map(response => response.value));
  }

  removeDiagnosisCodeFromPatient(patientId: number, diagnosisCodeId: number): Observable<boolean> {
    return this.api.delete<ItemDeletedResponse>('/diagnosiscodes/patient/' + patientId + '/' + diagnosisCodeId)
      .pipe(map(response => response.status.toLocaleUpperCase() === 'OK'));
  }
}
